export default "__VITE_ASSET__BTw_DU77__"